import { HTMLAttributes } from 'react';
import { CardContent } from '@/shared/ui/core';


export function RegistrationCardContent ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <CardContent
            className={ className }
            data-template="registration-card-content"
            { ...props }
        />
    );
}
